module.exports = [
	{
		"skillId": 1,
		"x": 15488,
		"y": 15104,
		"links": [
			2,
			6,
			158
		],
		"name": "Rebirthed Soul",
		"description": "A soul rebirthed acquires power unlimited. Use your skill points in this tree to empower your character. You can reset and change your skill points at any time. You must log out and log in for the skill tree changes to apply.",
		"size": 5,
		"color": "#ffffff",
		"payload": []
	},
	{
		"skillId": 2,
		"x": 15616,
		"y": 15488,
		"links": [
			1,
			3,
			261
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 3,
		"x": 15712,
		"y": 15808,
		"links": [
			2,
			4
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 4,
		"x": 15616,
		"y": 16128,
		"links": [
			3,
			5
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 5,
		"x": 15392,
		"y": 16480,
		"links": [
			4,
			9,
			14,
			77,
			233
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 6,
		"x": 16032,
		"y": 15488,
		"links": [
			1,
			7,
			12,
			160,
			258
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 7,
		"x": 16064,
		"y": 15776,
		"links": [
			6,
			8
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 8,
		"x": 16000,
		"y": 16192,
		"links": [
			7,
			9
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 9,
		"x": 15808,
		"y": 16608,
		"links": [
			8,
			5,
			10,
			13
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 10,
		"x": 16224,
		"y": 16736,
		"links": [
			11,
			9,
			15,
			52
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 11,
		"x": 16320,
		"y": 16320,
		"links": [
			12,
			10
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 12,
		"x": 16384,
		"y": 15840,
		"links": [
			6,
			11,
			159
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 13,
		"x": 15488,
		"y": 17184,
		"links": [
			9,
			17,
			14
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 14,
		"x": 15232,
		"y": 16800,
		"links": [
			13,
			5,
			83
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 15,
		"x": 16000,
		"y": 17312,
		"links": [
			10,
			16,
			51
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 16,
		"x": 15872,
		"y": 17536,
		"links": [
			15,
			20,
			210
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 17,
		"x": 15264,
		"y": 17664,
		"links": [
			13,
			22,
			18
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 18,
		"x": 14944,
		"y": 17280,
		"links": [
			83,
			17
		],
		"name": "Maximum HP per Level Keystone",
		"description": "+2 Maximum HP per level",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 19,
		"x": 14624,
		"y": 17824,
		"links": [
			22,
			26,
			161
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 20,
		"x": 15648,
		"y": 17600,
		"links": [
			16,
			21,
			152
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 21,
		"x": 15392,
		"y": 18144,
		"links": [
			23,
			20,
			24
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 22,
		"x": 15168,
		"y": 17856,
		"links": [
			17,
			19,
			23,
			161
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 23,
		"x": 15072,
		"y": 18048,
		"links": [
			22,
			21
		],
		"name": "Healing Others",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 24,
		"x": 15616,
		"y": 18336,
		"links": [
			25,
			21
		],
		"name": "Minor Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 25,
		"x": 15296,
		"y": 18976,
		"links": [
			27,
			24,
			42,
			230
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 26,
		"x": 14176,
		"y": 18528,
		"links": [
			29,
			19,
			33
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 27,
		"x": 14816,
		"y": 18656,
		"links": [
			28,
			25,
			151,
			153,
			149,
			253
		],
		"name": "Minor Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 28,
		"x": 14624,
		"y": 19168,
		"links": [
			32,
			27,
			220
		],
		"name": "Minor Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 29,
		"x": 14016,
		"y": 19136,
		"links": [
			30,
			26
		],
		"name": "Health Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 30,
		"x": 14272,
		"y": 19520,
		"links": [
			31,
			29,
			231
		],
		"name": "Health Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 31,
		"x": 14592,
		"y": 19904,
		"links": [
			32,
			30,
			227
		],
		"name": "Health Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 32,
		"x": 14560,
		"y": 19456,
		"links": [
			28,
			31,
			224
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 33,
		"x": 13824,
		"y": 17920,
		"links": [
			40,
			38,
			36,
			34,
			26
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 34,
		"x": 13664,
		"y": 17696,
		"links": [
			33,
			35
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 35,
		"x": 13440,
		"y": 17600,
		"links": [
			34
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 36,
		"x": 13632,
		"y": 17888,
		"links": [
			33,
			37
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 37,
		"x": 13440,
		"y": 17888,
		"links": [
			36,
			270
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 38,
		"x": 13632,
		"y": 18016,
		"links": [
			33,
			39
		],
		"name": "Common Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 39,
		"x": 13472,
		"y": 18240,
		"links": [
			38
		],
		"name": "Common Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 40,
		"x": 13792,
		"y": 18112,
		"links": [
			33,
			41
		],
		"name": "Attack",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 41,
		"x": 13824,
		"y": 18368,
		"links": [
			40
		],
		"name": "Attack",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 42,
		"x": 15744,
		"y": 18944,
		"links": [
			49,
			47,
			45,
			43,
			25
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 43,
		"x": 15744,
		"y": 19136,
		"links": [
			42,
			44
		],
		"name": "Magic Level",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 44,
		"x": 15616,
		"y": 19296,
		"links": [
			43
		],
		"name": "Magic Level",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 45,
		"x": 15904,
		"y": 19104,
		"links": [
			42,
			46
		],
		"name": "All Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 46,
		"x": 15904,
		"y": 19360,
		"links": [
			45
		],
		"name": "All Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 47,
		"x": 15936,
		"y": 18912,
		"links": [
			42,
			48
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 48,
		"x": 16096,
		"y": 18944,
		"links": [
			47,
			269
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 49,
		"x": 15808,
		"y": 18784,
		"links": [
			42,
			50
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 50,
		"x": 16096,
		"y": 18688,
		"links": [
			49
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 51,
		"x": 16736,
		"y": 17536,
		"links": [
			15,
			62,
			210
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 52,
		"x": 16672,
		"y": 16864,
		"links": [
			10,
			53,
			116
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 53,
		"x": 17152,
		"y": 16992,
		"links": [
			54,
			52,
			117,
			147
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 54,
		"x": 17568,
		"y": 17184,
		"links": [
			55,
			53,
			119,
			147
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 55,
		"x": 17888,
		"y": 17440,
		"links": [
			56,
			54,
			122
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 56,
		"x": 18016,
		"y": 17856,
		"links": [
			57,
			55,
			125
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 57,
		"x": 17952,
		"y": 18272,
		"links": [
			58,
			56,
			128,
			148,
			254
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 58,
		"x": 17824,
		"y": 18688,
		"links": [
			59,
			57,
			131
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 59,
		"x": 17472,
		"y": 19104,
		"links": [
			60,
			58,
			135
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 60,
		"x": 17024,
		"y": 19328,
		"links": [
			61,
			59,
			139,
			249
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 61,
		"x": 16512,
		"y": 19392,
		"links": [
			66,
			60,
			143
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 62,
		"x": 17152,
		"y": 17696,
		"links": [
			63,
			51,
			147
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 63,
		"x": 17472,
		"y": 18048,
		"links": [
			64,
			62,
			148
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 64,
		"x": 17312,
		"y": 18464,
		"links": [
			65,
			63,
			217
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 65,
		"x": 17088,
		"y": 18752,
		"links": [
			66,
			64,
			228
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 66,
		"x": 16800,
		"y": 19072,
		"links": [
			61,
			65
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 67,
		"x": 14624,
		"y": 16768,
		"links": [
			68,
			83,
			84
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 68,
		"x": 14112,
		"y": 16512,
		"links": [
			69,
			67,
			85,
			155
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 69,
		"x": 13536,
		"y": 16192,
		"links": [
			70,
			68,
			87,
			155
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 70,
		"x": 13216,
		"y": 15680,
		"links": [
			71,
			69,
			90,
			250
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 71,
		"x": 13088,
		"y": 15168,
		"links": [
			72,
			70,
			93,
			156
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 72,
		"x": 13120,
		"y": 14592,
		"links": [
			73,
			71,
			96,
			156,
			276
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 73,
		"x": 13216,
		"y": 14048,
		"links": [
			74,
			72,
			100
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 74,
		"x": 13568,
		"y": 13632,
		"links": [
			75,
			73,
			104,
			157
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 75,
		"x": 14016,
		"y": 13472,
		"links": [
			76,
			74,
			108
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 76,
		"x": 14496,
		"y": 13472,
		"links": [
			82,
			75,
			112,
			214,
			257,
			280
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 77,
		"x": 14752,
		"y": 16224,
		"links": [
			5,
			78,
			215
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 78,
		"x": 14240,
		"y": 15776,
		"links": [
			77,
			79,
			155,
			277
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 79,
		"x": 13824,
		"y": 15232,
		"links": [
			78,
			80,
			156
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 80,
		"x": 13792,
		"y": 14656,
		"links": [
			79,
			81,
			156
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 81,
		"x": 13888,
		"y": 14112,
		"links": [
			80,
			82,
			157
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 82,
		"x": 14112,
		"y": 13824,
		"links": [
			81,
			76,
			279
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 83,
		"x": 15072,
		"y": 17056,
		"links": [
			14,
			18,
			67
		],
		"name": "Minor Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 84,
		"x": 14368,
		"y": 17152,
		"links": [
			67,
			204,
			281
		],
		"name": "Defense",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 85,
		"x": 13792,
		"y": 16832,
		"links": [
			68,
			86
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 86,
		"x": 13408,
		"y": 17184,
		"links": [
			85,
			204,
			283
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 87,
		"x": 13280,
		"y": 16416,
		"links": [
			88,
			69
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 88,
		"x": 12864,
		"y": 16640,
		"links": [
			89,
			87,
			206
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 89,
		"x": 12416,
		"y": 16832,
		"links": [
			88
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 90,
		"x": 12768,
		"y": 15776,
		"links": [
			70,
			91
		],
		"name": "Armor",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 91,
		"x": 12320,
		"y": 15904,
		"links": [
			90,
			92
		],
		"name": "Armor",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 92,
		"x": 11712,
		"y": 16000,
		"links": [
			91
		],
		"name": "Armor Keystone",
		"description": "8% of your Defense is added as Armor",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 93,
		"x": 12640,
		"y": 15136,
		"links": [
			71,
			94,
			255
		],
		"name": "Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 94,
		"x": 12160,
		"y": 15136,
		"links": [
			93,
			95,
			218
		],
		"name": "Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 95,
		"x": 11616,
		"y": 15104,
		"links": [
			94,
			275
		],
		"name": "Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 96,
		"x": 12640,
		"y": 14464,
		"links": [
			72,
			97,
			201,
			218
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 97,
		"x": 12064,
		"y": 14240,
		"links": [
			96,
			99
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 98,
		"x": 11104,
		"y": 13664,
		"links": [
			99
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 99,
		"x": 11584,
		"y": 14048,
		"links": [
			97,
			98
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 100,
		"x": 12832,
		"y": 13760,
		"links": [
			73,
			101,
			164
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 101,
		"x": 12256,
		"y": 13408,
		"links": [
			100,
			102
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 102,
		"x": 11808,
		"y": 13120,
		"links": [
			101,
			103
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 103,
		"x": 11424,
		"y": 12640,
		"links": [
			102
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 104,
		"x": 13376,
		"y": 13248,
		"links": [
			74,
			105,
			165
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 105,
		"x": 12992,
		"y": 12896,
		"links": [
			104,
			106
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 106,
		"x": 12544,
		"y": 12448,
		"links": [
			105,
			107,
			274
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 107,
		"x": 12256,
		"y": 11936,
		"links": [
			106
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 108,
		"x": 13920,
		"y": 13088,
		"links": [
			75,
			109,
			171,
			168
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 109,
		"x": 13728,
		"y": 12544,
		"links": [
			108,
			110
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 110,
		"x": 13600,
		"y": 11936,
		"links": [
			109,
			111
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 111,
		"x": 13568,
		"y": 11264,
		"links": [
			110
		],
		"name": "Attack Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 112,
		"x": 14656,
		"y": 13120,
		"links": [
			76,
			113,
			177,
			174
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 113,
		"x": 14816,
		"y": 12416,
		"links": [
			112,
			114
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 114,
		"x": 14848,
		"y": 11776,
		"links": [
			113,
			115
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 115,
		"x": 14976,
		"y": 11200,
		"links": [
			114
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 116,
		"x": 16768,
		"y": 16256,
		"links": [
			52,
			208,
			273
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 117,
		"x": 17312,
		"y": 16416,
		"links": [
			118,
			53
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 118,
		"x": 17440,
		"y": 15936,
		"links": [
			117,
			208
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 119,
		"x": 17792,
		"y": 16704,
		"links": [
			120,
			54
		],
		"name": "Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 120,
		"x": 18048,
		"y": 16320,
		"links": [
			121,
			119,
			207
		],
		"name": "Maximum Mana",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 121,
		"x": 18624,
		"y": 16160,
		"links": [
			120
		],
		"name": "Maximum Mana Keystone",
		"description": "+3 Maximum Mana per level",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 122,
		"x": 18176,
		"y": 17216,
		"links": [
			123,
			55
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 123,
		"x": 18528,
		"y": 16992,
		"links": [
			124,
			122
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 124,
		"x": 18976,
		"y": 16800,
		"links": [
			123
		],
		"name": "Deflection Keystone",
		"description": "8% of your Armor is added as Deflection, or 20% if you are wielding a 2-handed weapon",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 125,
		"x": 18336,
		"y": 17760,
		"links": [
			126,
			56
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 126,
		"x": 18816,
		"y": 17760,
		"links": [
			127,
			125
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 127,
		"x": 19488,
		"y": 17888,
		"links": [
			126
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 128,
		"x": 18400,
		"y": 18304,
		"links": [
			129,
			57
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 129,
		"x": 18816,
		"y": 18368,
		"links": [
			130,
			128,
			219
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 130,
		"x": 19616,
		"y": 18688,
		"links": [
			129
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 131,
		"x": 18176,
		"y": 18848,
		"links": [
			132,
			58,
			198,
			219
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 132,
		"x": 18656,
		"y": 19072,
		"links": [
			133,
			131
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 133,
		"x": 19136,
		"y": 19488,
		"links": [
			134,
			132
		],
		"name": "Magic Level",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 134,
		"x": 19712,
		"y": 19872,
		"links": [
			133
		],
		"name": "Magic Level",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 135,
		"x": 17696,
		"y": 19360,
		"links": [
			136,
			59,
			197,
			192
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 136,
		"x": 17984,
		"y": 19808,
		"links": [
			137,
			135
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 137,
		"x": 18304,
		"y": 20256,
		"links": [
			138,
			136
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 138,
		"x": 18496,
		"y": 20896,
		"links": [
			137
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 139,
		"x": 17120,
		"y": 19648,
		"links": [
			140,
			60,
			191,
			186
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 140,
		"x": 17216,
		"y": 20160,
		"links": [
			141,
			139
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 141,
		"x": 17312,
		"y": 20544,
		"links": [
			142,
			140
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 142,
		"x": 17248,
		"y": 21248,
		"links": [
			141
		],
		"name": "Fortitude",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 143,
		"x": 16448,
		"y": 19744,
		"links": [
			61,
			144,
			180,
			181
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 144,
		"x": 16224,
		"y": 20192,
		"links": [
			143,
			145
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 145,
		"x": 15904,
		"y": 20512,
		"links": [
			144,
			146
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 146,
		"x": 15328,
		"y": 20864,
		"links": [
			145,
			268
		],
		"name": "All Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 147,
		"x": 17280,
		"y": 17376,
		"links": [
			62,
			53,
			54,
			252
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 148,
		"x": 17568,
		"y": 18336,
		"links": [
			57,
			217,
			63
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 149,
		"x": 14656,
		"y": 18400,
		"links": [
			27,
			150
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 150,
		"x": 14624,
		"y": 18112,
		"links": [
			149
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 151,
		"x": 14944,
		"y": 18272,
		"links": [
			27
		],
		"name": "Healing Others Keystone",
		"description": "All healing on others also restores 10% of their mana",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 152,
		"x": 15744,
		"y": 17216,
		"links": [
			20,
			232
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 153,
		"x": 15072,
		"y": 18528,
		"links": [
			27,
			154
		],
		"name": "Healing Others",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 154,
		"x": 15296,
		"y": 18400,
		"links": [
			153
		],
		"name": "Healing Others",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 155,
		"x": 14016,
		"y": 16096,
		"links": [
			69,
			68,
			78,
			251
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 156,
		"x": 13440,
		"y": 14848,
		"links": [
			71,
			79,
			80,
			72
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 157,
		"x": 13664,
		"y": 13888,
		"links": [
			74,
			81,
			256
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 158,
		"x": 15968,
		"y": 14912,
		"links": [
			1,
			159,
			160
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 159,
		"x": 16384,
		"y": 15392,
		"links": [
			158,
			12,
			258
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 160,
		"x": 15872,
		"y": 15200,
		"links": [
			158,
			6
		],
		"name": "The Phoenix Keystone",
		"description": "While you are below rank 50, when you take a fatal hit, you have a 10% chance to recover 75% health and 100% mana",
		"size": 5,
		"color": "#f44336",
		"payload": []
	},
	{
		"skillId": 161,
		"x": 14784,
		"y": 17536,
		"links": [
			22,
			19
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 162,
		"x": 11680,
		"y": 12416,
		"links": [
			163
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 163,
		"x": 11968,
		"y": 12864,
		"links": [
			164,
			162
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 164,
		"x": 12448,
		"y": 13184,
		"links": [
			100,
			163
		],
		"name": "Deflection",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 165,
		"x": 13184,
		"y": 12736,
		"links": [
			104,
			166
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 166,
		"x": 12864,
		"y": 12352,
		"links": [
			165,
			167
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 167,
		"x": 12544,
		"y": 11744,
		"links": [
			166
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 168,
		"x": 13984,
		"y": 12480,
		"links": [
			108,
			169
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 169,
		"x": 13888,
		"y": 11904,
		"links": [
			168,
			170
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 170,
		"x": 13952,
		"y": 11232,
		"links": [
			169
		],
		"name": "Maximum HP",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 171,
		"x": 14176,
		"y": 12416,
		"links": [
			108,
			172
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 172,
		"x": 14176,
		"y": 11840,
		"links": [
			171,
			173
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 173,
		"x": 14304,
		"y": 11232,
		"links": [
			172
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 174,
		"x": 15104,
		"y": 12512,
		"links": [
			112,
			175
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 175,
		"x": 15264,
		"y": 11936,
		"links": [
			174,
			176
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 176,
		"x": 15424,
		"y": 11296,
		"links": [
			175
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 177,
		"x": 15264,
		"y": 12800,
		"links": [
			112,
			178
		],
		"name": "Healing Others",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 178,
		"x": 15616,
		"y": 12256,
		"links": [
			177,
			179
		],
		"name": "Healing Others",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 179,
		"x": 15840,
		"y": 11456,
		"links": [
			178
		],
		"name": "Healing Others",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 180,
		"x": 16512,
		"y": 20288,
		"links": [
			184,
			143
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 181,
		"x": 15840,
		"y": 20128,
		"links": [
			143,
			182
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 182,
		"x": 15392,
		"y": 20384,
		"links": [
			181,
			183
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 183,
		"x": 14784,
		"y": 20576,
		"links": [
			182
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 184,
		"x": 16064,
		"y": 20800,
		"links": [
			180,
			185
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 185,
		"x": 15360,
		"y": 21248,
		"links": [
			184
		],
		"name": "Summon Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 186,
		"x": 16896,
		"y": 20160,
		"links": [
			139,
			187
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 187,
		"x": 16896,
		"y": 20576,
		"links": [
			186,
			188
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 188,
		"x": 16832,
		"y": 20896,
		"links": [
			187,
			271,
			272
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 189,
		"x": 17632,
		"y": 21184,
		"links": [
			190
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 190,
		"x": 17600,
		"y": 20480,
		"links": [
			191,
			189
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 191,
		"x": 17472,
		"y": 20096,
		"links": [
			139,
			190
		],
		"name": "Critical Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 192,
		"x": 17760,
		"y": 19936,
		"links": [
			135,
			193
		],
		"name": "Movement Speed",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 193,
		"x": 18048,
		"y": 20352,
		"links": [
			192,
			194
		],
		"name": "Movement Speed",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 194,
		"x": 18208,
		"y": 21024,
		"links": [
			193
		],
		"name": "Movement Speed",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 195,
		"x": 18848,
		"y": 20768,
		"links": [
			196
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 196,
		"x": 18560,
		"y": 20064,
		"links": [
			197,
			195
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 197,
		"x": 18208,
		"y": 19648,
		"links": [
			135,
			196
		],
		"name": "Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 198,
		"x": 18432,
		"y": 19264,
		"links": [
			131,
			199
		],
		"name": "Attack",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 199,
		"x": 18912,
		"y": 19680,
		"links": [
			198,
			200
		],
		"name": "Attack",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 200,
		"x": 19424,
		"y": 20224,
		"links": [
			199
		],
		"name": "Attack",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 201,
		"x": 12032,
		"y": 14528,
		"links": [
			96,
			202
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 202,
		"x": 11392,
		"y": 14336,
		"links": [
			201,
			203
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 203,
		"x": 10976,
		"y": 14048,
		"links": [
			202
		],
		"name": "Spell Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 204,
		"x": 13920,
		"y": 17152,
		"links": [
			84,
			86,
			205,
			282
		],
		"name": "Defense",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 205,
		"x": 14144,
		"y": 16832,
		"links": [
			204
		],
		"name": "Defense Keystone",
		"description": "+1 Defense per 4 levels",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 206,
		"x": 12640,
		"y": 17056,
		"links": [
			88
		],
		"name": "Self Healing",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 207,
		"x": 18336,
		"y": 15872,
		"links": [
			120
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 208,
		"x": 17088,
		"y": 16096,
		"links": [
			116,
			118,
			209
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 209,
		"x": 16992,
		"y": 16448,
		"links": [
			208
		],
		"name": "Critical Damage Keystone",
		"description": "15% increased Critical Strike Damage",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 210,
		"x": 16256,
		"y": 17568,
		"links": [
			16,
			51,
			216
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 211,
		"x": 14496,
		"y": 15296,
		"links": [
			212,
			215
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 212,
		"x": 14336,
		"y": 14880,
		"links": [
			213,
			211
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 213,
		"x": 14336,
		"y": 14432,
		"links": [
			214,
			212,
			234
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 214,
		"x": 14336,
		"y": 13984,
		"links": [
			76,
			213,
			279
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 215,
		"x": 14624,
		"y": 15712,
		"links": [
			211,
			77,
			277
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 216,
		"x": 16800,
		"y": 17792,
		"links": [
			210,
			217
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 217,
		"x": 17184,
		"y": 18144,
		"links": [
			216,
			64,
			148
		],
		"name": "Minor Experience Gain",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 218,
		"x": 12384,
		"y": 14752,
		"links": [
			94,
			96
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 219,
		"x": 18496,
		"y": 18624,
		"links": [
			129,
			131
		],
		"name": "Armor",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 220,
		"x": 14912,
		"y": 19520,
		"links": [
			28,
			221,
			230
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 221,
		"x": 15200,
		"y": 19712,
		"links": [
			220,
			222
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 222,
		"x": 15520,
		"y": 19808,
		"links": [
			221,
			223
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 223,
		"x": 15840,
		"y": 19776,
		"links": [
			222,
			229
		],
		"name": "Critical Chance",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 224,
		"x": 14816,
		"y": 19712,
		"links": [
			32,
			225
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 225,
		"x": 15072,
		"y": 19904,
		"links": [
			224,
			226
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 226,
		"x": 15392,
		"y": 20000,
		"links": [
			225
		],
		"name": "Mana Regeneration",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 227,
		"x": 14976,
		"y": 20192,
		"links": [
			31
		],
		"name": "Health Regen Keystone",
		"description": "30% increased Health Regeneration, -5 Armor",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 228,
		"x": 17408,
		"y": 18784,
		"links": [
			65
		],
		"name": "Deflection Attack Keystone",
		"description": "10% of your primary skill/magic level is added as Deflection",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 229,
		"x": 16128,
		"y": 19584,
		"links": [
			223
		],
		"name": "Crit Chance Keystone",
		"description": "Your Critical Chance is rolled twice, increasing your chance to land a Critical, 10% less Critical Damage",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 230,
		"x": 14880,
		"y": 19008,
		"links": [
			25,
			231,
			220
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 231,
		"x": 14368,
		"y": 19104,
		"links": [
			230,
			30,
			264
		],
		"name": "Rare Loot Drops",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 232,
		"x": 15872,
		"y": 16928,
		"links": [
			152,
			233
		],
		"name": "Damage per Level Keystone",
		"description": "+1.5 base Damage per level",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 233,
		"x": 15520,
		"y": 16768,
		"links": [
			5,
			232
		],
		"name": "Minor Damage",
		"size": 3,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 234,
		"x": 14656,
		"y": 14464,
		"links": [
			213
		],
		"name": "Experience Gain Keystone",
		"description": "While you are not at maximum ranklevel, 15% increased Experience gains",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 235,
		"x": 15616,
		"y": 10496,
		"links": [
			246
		],
		"name": "Nameless",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 236,
		"x": 15616,
		"y": 21760,
		"links": [
			239
		],
		"name": "Nameless",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 237,
		"x": 21248,
		"y": 16128,
		"links": [
			244
		],
		"name": "Nameless",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 238,
		"x": 9984,
		"y": 16128,
		"links": [
			241
		],
		"name": "Nameless",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 239,
		"x": 14080,
		"y": 21504,
		"links": [
			240,
			236
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 240,
		"x": 12544,
		"y": 20992,
		"links": [
			243,
			239
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 241,
		"x": 10240,
		"y": 17664,
		"links": [
			242,
			238
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 242,
		"x": 10752,
		"y": 19200,
		"links": [
			241,
			243
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 243,
		"x": 11520,
		"y": 20224,
		"links": [
			242,
			240
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 244,
		"x": 20992,
		"y": 14592,
		"links": [
			245,
			237
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 245,
		"x": 20480,
		"y": 13056,
		"links": [
			244,
			248
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 246,
		"x": 17152,
		"y": 10752,
		"links": [
			247,
			235
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 247,
		"x": 18688,
		"y": 11264,
		"links": [
			248,
			246
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 248,
		"x": 19712,
		"y": 12032,
		"links": [
			245,
			247
		],
		"name": "Nameless",
		"size": 4,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 249,
		"x": 17408,
		"y": 19520,
		"links": [
			60
		],
		"name": "Increased Range Keystone",
		"description": "Your range is increased by 1 with all weapons, -20 Defense",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 250,
		"x": 13728,
		"y": 15744,
		"links": [
			70
		],
		"name": "Only Crits Keystone",
		"description": "40% increased Critical Damage, 5% decreased Critical Chance",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 251,
		"x": 14336,
		"y": 16288,
		"links": [
			155
		],
		"name": "Summon Regen Keystone",
		"description": "Summon Health Regen is increased by 100%",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 252,
		"x": 16768,
		"y": 17184,
		"links": [
			147
		],
		"name": "Movement Speed Keystone",
		"description": "+120 Movement Speed",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 253,
		"x": 14400,
		"y": 18720,
		"links": [
			27
		],
		"name": "Health Loop Keystone",
		"description": "5% of Health you lose is recovered as Mana",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 254,
		"x": 17696,
		"y": 17856,
		"links": [
			57
		],
		"name": "Mana Siphon Keystone",
		"description": "40% of Mana you SPEND is recovered as Health",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 255,
		"x": 12768,
		"y": 14848,
		"links": [
			93
		],
		"name": "Mana Leech Keystone",
		"description": "1% of Damage you deal is recovered as Mana (leech applied before difficulty modifiers)",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 256,
		"x": 13504,
		"y": 14272,
		"links": [
			157
		],
		"name": "Health Leech Keystone",
		"description": "2% of Damage you deal is recovered as Health (leech applied before difficulty modifiers)",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 257,
		"x": 15040,
		"y": 13312,
		"links": [
			76
		],
		"name": "Healing Recursion Keystone",
		"description": "All healing on others also heals you for 10% of that amount",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 258,
		"x": 16736,
		"y": 15648,
		"links": [
			159,
			259,
			6
		],
		"name": "Common Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 259,
		"x": 17024,
		"y": 15648,
		"links": [
			258,
			260
		],
		"name": "Common Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 260,
		"x": 17216,
		"y": 15456,
		"links": [
			259
		],
		"name": "Common Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 261,
		"x": 15360,
		"y": 15680,
		"links": [
			2,
			262
		],
		"name": "Rare Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 262,
		"x": 15104,
		"y": 15648,
		"links": [
			261,
			263
		],
		"name": "Rare Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 263,
		"x": 14880,
		"y": 15488,
		"links": [
			262
		],
		"name": "Rare Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 264,
		"x": 14016,
		"y": 19584,
		"links": [
			231,
			265
		],
		"name": "All Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 265,
		"x": 14080,
		"y": 19968,
		"links": [
			264,
			266
		],
		"name": "All Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 266,
		"x": 14304,
		"y": 20192,
		"links": [
			265,
			267
		],
		"name": "All Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 267,
		"x": 14560,
		"y": 20384,
		"links": [
			266
		],
		"name": "All Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 268,
		"x": 14912,
		"y": 21024,
		"links": [
			146
		],
		"name": "All Damage",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 269,
		"x": 16224,
		"y": 19040,
		"links": [
			48
		],
		"name": "Critical Damage",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 270,
		"x": 13248,
		"y": 17984,
		"links": [
			37
		],
		"name": "Critical Damage",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 271,
		"x": 16608,
		"y": 21248,
		"links": [
			188
		],
		"name": "Critical Chance",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 272,
		"x": 16864,
		"y": 21248,
		"links": [
			188
		],
		"name": "Critical Chance",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 273,
		"x": 16800,
		"y": 15968,
		"links": [
			116
		],
		"name": "Critical Chance",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 274,
		"x": 12032,
		"y": 12096,
		"links": [
			106
		],
		"name": "Critical Chance Keystone",
		"description": "+10% Critical Chance",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 275,
		"x": 11008,
		"y": 14944,
		"links": [
			95
		],
		"name": "Learned Mana Keystone",
		"description": "+10 Maximum Mana per Rank",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 276,
		"x": 12864,
		"y": 14208,
		"links": [
			72
		],
		"name": "Backpack Hero Keystone",
		"description": "+10% chance to drop ALL loot from monsters, -15% ALL Damage, -20 max Health per Rank",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 277,
		"x": 14240,
		"y": 15392,
		"links": [
			78,
			215,
			278
		],
		"name": "Deflection",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 278,
		"x": 14080,
		"y": 15040,
		"links": [
			277,
			279
		],
		"name": "Deflection",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 279,
		"x": 14080,
		"y": 14400,
		"links": [
			278,
			214,
			82
		],
		"name": "Deflection",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 280,
		"x": 14720,
		"y": 13728,
		"links": [
			76
		],
		"name": "Scavenger Keystone",
		"description": "+15% chance to drop Common and Uncommon loot from monsters",
		"size": 5,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 281,
		"x": 14144,
		"y": 17472,
		"links": [
			84
		],
		"name": "Defense",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 282,
		"x": 13728,
		"y": 17408,
		"links": [
			204
		],
		"name": "Defense",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	},
	{
		"skillId": 283,
		"x": 13088,
		"y": 17472,
		"links": [
			86
		],
		"name": "Rare Loot Drops",
		"size": 2,
		"color": "#ffc107",
		"payload": []
	}
];